module.exports = __webpack_public_path__ + "static/media/pizzatakeaway.29a95583.svg";